import * as React from 'react';
import { css } from 'styled-components';
import { Box } from '@aksara-ui/core';

import { IndexLayout } from '../layouts/index';
import { SignupForm, SignupSuccess } from '../components/auth/signup';
import { AuthWrapper } from '../components/auth/AuthWrapper';

import Logo from '../assets/images/logo-platform.png';

interface SignupPageState {
  signupComplete: boolean;
  signedUpEmail: string;
}

class SignupPage extends React.Component<{}, SignupPageState> {
  constructor(props: {}) {
    super(props);

    this.state = {
      signupComplete: false,
      signedUpEmail: '',
    };
  }

  public render() {
    const { signupComplete, signedUpEmail } = this.state;

    return (
      <IndexLayout>
        <AuthWrapper>
          <Box display="flex" alignItems="center" justifyContent="center" flex="6 1 auto" backgroundColor="grey01">
            <Box display="block" width="100%" maxWidth={600} p="xxl">
              <Box mb="xxl">
                <img
                  src={Logo}
                  className="auth-logo"
                  alt="logo"
                  css={css`
                    height: 48px;
                  `}
                />
              </Box>
              {signupComplete ? (
                <SignupSuccess email={signedUpEmail} />
              ) : (
                <SignupForm
                  onSuccess={values => {
                    this.setState({
                      signupComplete: true,
                      signedUpEmail: values.email,
                    });
                  }}
                />
              )}
            </Box>
          </Box>
        </AuthWrapper>
      </IndexLayout>
    );
  }
}

export default SignupPage;
